// Pro API - Analytics Operations
import { request } from "../base";

export type ProStats = {
	summary: {
		totalPageViews: number;
		totalProjectClicks: number;
		totalWhatsappClicks: number;
		totalCallClicks: number;
		totalInquiries: number;
		views7d: number;
		views30d: number;
		clicks7d: number;
		clicks30d: number;
		lastViewAt: string | null;
		lastClickAt: string | null;
	};
	daily: {
		date: string;
		pageViews: number;
		projectClicks: number;
		imageClicks: number;
		whatsappClicks: number;
		callClicks: number;
		inquiryClicks: number;
		uniqueSessions: number;
	}[];
	topProjects: {
		id: string;
		title: string;
		slug: string | null;
		views: number;
	}[];
	sources: Record<string, number>;
	devices: Record<string, number>;
	cities: Record<string, number>;
};

export const analyticsApi = {
	async getProStats(proId: string) {
		return request<ProStats>(`/api/stats/pro/${proId}`);
	},
};
